const newFleetInfo = {
  bindings: {
    settings: '<',
    area: '<',
    gridlet: '<',
  },
  templateUrl: '/modules/gridlets/new-fleet-info/new-fleet-info.html',
  controller: 'NewFleetInfoController',
};

angular
  .module('gridlets.module')
  .component('newFleetInfo', newFleetInfo);